import script from "./WCProductRowModern.vue?vue&type=script&setup=true&lang=ts"
export * from "./WCProductRowModern.vue?vue&type=script&setup=true&lang=ts"

import "./WCProductRowModern.vue?vue&type=style&index=0&id=16c8f940&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16c8f940"]])

export default __exports__